import { mountPage } from "../../libs/page-entry";
import { CouponPage } from "./CouponPage";

mountPage(CouponPage);
